import * as types from './types'

export const clearStores = () => ({
    type: types.CLEAR_STORE
})